import { EventLinksState } from "./types";

export function getDefaultState(): EventLinksState {
	return {
		eventLinkTableResponse: {
			eventLinks: {
				data: [],
				pageNumber: 1,
				pageSize: 0,
				totalRecords: 0,
			},
			noPermissionCount: 0
		},
		eventLinkListResponse: {
			eventLinks: {
				data: [],
				pageNumber: 1,
				pageSize: 0,
				totalRecords: 0,
			},
			noPermissionCount: 0
		},
	};
}
